import React, { useState } from "react";
const axios = require("axios");
const constants = require("../../../constant");

function Addtrainingform() {
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [trainingName, setTrainingName] = useState("");
    const [trainingDescription, setTrainingDescription] = useState("");
    const [trainingCertificate, setTrainingCertificate] = useState(null);
    return (
        <>
            <div className="main-container">
                <div className="pd-ltr-20 xs-pd-20-10">
                    <div className="min-height-200px">
                        <div className="page-header">
                            <div className="row">
                                <div className="col-md-6 col-sm-12">
                                    <div className="title">
                                        <h4>Add Trainings</h4>
                                    </div>
                                    <nav
                                        aria-label="breadcrumb"
                                        role="navigation"
                                    >
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item">
                                                <a href="/dashboard">Home</a>
                                            </li>
                                            <li className="breadcrumb-item">
                                                Trainings
                                            </li>
                                            <li
                                                className="breadcrumb-item active"
                                                aria-current="page"
                                            >
                                                Add Trainings
                                            </li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
                        <div className="pd-20 card-box mb-30">
                            <div className="wizard-content">
                                <form className="tab-wizard wizard-circle wizard">
                                    <section>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>From-Date :</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        placeholder="Select From Date"
                                                        value={startDate}
                                                        onChange={(e) => {
                                                            setStartDate(
                                                                e.target.value
                                                            );
                                                            console.log(
                                                                startDate
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>To-Date :</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        placeholder="Select To Date"
                                                        value={endDate}
                                                        onChange={(e) => {
                                                            setEndDate(
                                                                e.target.value
                                                            );
                                                            console.log(
                                                                endDate
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>
                                                        Name of Training:
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter title of training"
                                                        value={trainingName}
                                                        onChange={(e) => {
                                                            setTrainingName(
                                                                e.target.value
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 ">
                                                {/* <div class="form-group"> */}
                                                <label>
                                                    Upload Participation Proof:
                                                </label>
                                                {/* <div class="custom-file "> */}
                                                {/* <input
                                                            type="file"
                                                            class="custom-file-input"
                                                            value={
                                                                trainingCertificate
                                                            }
                                                            accept="pdf"
                                                            onChange={(e) => {
                                                                setTrainingCertificate(
                                                                    e.target
                                                                        .files[0]
                                                                );
                                                                console.log(e.target.files[0]);
                                                            }}
                                                        /> */}
                                                {/* <input
                                                    type="file"
                                                    value={trainingCertificate}
                                                    onChange={(e) => {
                                                        // setTrainingCertificate(
                                                        //     e.target
                                                        //         .files[0]
                                                        // );
                                                        console.log(
                                                            e.target.files[0]
                                                        );
                                                    }}
                                                /> */}
                                                {/* <label class="custom-file-label">
                                                    Choose file
                                                </label> */}
                                                {/* </div> */}
                                                {/* </div> */}
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    placeholder="Enter title of training"
                                                    // value={trainingCertificate}
                                                    onChange={(e) => {
                                                        try {
                                                            console.log(
                                                                e.target
                                                                    .files[0]
                                                            );
                                                            setTrainingCertificate(
                                                                e.target
                                                                    .files[0]
                                                            );
                                                        } catch (err) {
                                                            console.log(err);
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Description :</label>
                                                    <textarea
                                                        className="form-control"
                                                        defaultValue={
                                                            trainingDescription
                                                        }
                                                        onChange={(e) => {
                                                            setTrainingDescription(
                                                                e.target.value
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-12 col-md-12 col-form-label"></label>
                                            <div className="col-sm-12 col-md-10">
                                                <input
                                                    className="btn btn-primary"
                                                    type="submit"
                                                    defaultValue="Submit"
                                                    onClick={async (e) => {
                                                        e.preventDefault();
                                                        console.log(
                                                            "asdsadsa",
                                                            startDate,
                                                            endDate,
                                                            trainingName,
                                                            trainingDescription,
                                                            trainingCertificate
                                                        );
                                                        const formData =
                                                            new FormData();
                                                        formData.append(
                                                            "startDate",
                                                            startDate
                                                        );
                                                        formData.append(
                                                            "endDate",
                                                            endDate
                                                        );
                                                        formData.append(
                                                            "trainingName",
                                                            trainingName
                                                        );
                                                        formData.append(
                                                            "trainingDescription",
                                                            trainingDescription
                                                        );
                                                        formData.append(
                                                            "trainingCertificate",
                                                            trainingCertificate
                                                        );
                                                        formData.append(
                                                            "token",
                                                            localStorage.getItem(
                                                                "token"
                                                            )
                                                        );
                                                        console.log(
                                                            "formData",
                                                            trainingCertificate
                                                        );
                                                        const result =
                                                            await axios({
                                                                method: "post",
                                                                url: `${constants.backendUrl}/addTraining`,
                                                                data: formData,
                                                                headers: {
                                                                    "Content-Type":
                                                                        "multipart/form-data",
                                                                },
                                                            });
                                                        console.log(result);
                                                        if (
                                                            result.data
                                                                .success === true
                                                        ) {
                                                            alert(
                                                                "Training Added Successfully"
                                                            );
                                                        } else {
                                                            alert(
                                                                "Error Adding Training"
                                                            );
                                                        }
                                                        setStartDate("");
                                                        setEndDate("");
                                                        setTrainingName("");
                                                        setTrainingDescription(
                                                            ""
                                                        );
                                                        setTrainingCertificate(
                                                            ""
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </section>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Addtrainingform;
